// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__Dse1K"};